<template>
   <TaxStandard :AllowEdit="true"/>
</template>
<script>
import TaxStandard from '@/components//DPEBB/Administrator/TaxStandard.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
        AppServiceID :6, 
        }
    },
 components: {
        TaxStandard
    },
   created: function() {
        this.$emit('update:layout', LayoutDefault);
    },
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    },
}
</script>